// @flow

import styled from '@emotion/styled'

export default styled('div')`
  display: flex;
  flex-direction: ${props => (props.direction ? props.direction : 'row')};
  flex-wrap: wrap;
  row-gap: ${props => (props.rowGap !== undefined ? props.rowGap : '8px')};
  margin-bottom: ${props => (props.marginBottom !== undefined ? props.marginBottom : '8px')};
  min-height: ${props =>
    props.minHeight !== undefined ? props.minHeight : 'auto'};
`;
